import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';

import { ParticulierMouvement } from '../../api/model/particulier-mouvement.model';
import { ChangementCoordonneeMouvementService } from '@services/changement-coordonnee-mouvement/changement-coordonnee-mouvement.service';
import { RequeteModifierCoordonneesMouvement } from '../../api/model/requete-modifier-coordonnees-mouvement.model';
import { ReponseModifierCoordonneesMouvement } from 'src/app/api/model/reponse-modifier-coordonnees-mouvement.model';
import { ContexteModificationEnum } from '../../constantes/contexte-modification.enum';

@Injectable({
  providedIn: 'root',
})
export class GlobalStoreService {
  private readonly updateDataForm = new BehaviorSubject<RequeteModifierCoordonneesMouvement | null>(
    null,
  );
  private readonly coordonneesMouvement = new BehaviorSubject<ParticulierMouvement | null>(null);
  private readonly confirmationMouvement =
    new BehaviorSubject<ReponseModifierCoordonneesMouvement | null>(null);
  private readonly etatModale = new BehaviorSubject<boolean>(false);
  private readonly etatErreur = new BehaviorSubject<HttpErrorResponse | null>(null);
  private readonly selector = new BehaviorSubject<string>('h1');
  private etatModification: string = '';
  private contexteModification!: ContexteModificationEnum;

  private readonly changementCoordonneeMouvementService = inject(
    ChangementCoordonneeMouvementService,
  );

  constructor() {}

  saveUpdateDataForm(requeteModifierCoordonnees: RequeteModifierCoordonneesMouvement | null): void {
    this.updateDataForm.next(requeteModifierCoordonnees);
  }
  getUpdateDataForm(): Observable<RequeteModifierCoordonneesMouvement | null> {
    return this.updateDataForm.asObservable();
  }

  getCoordonneesMouvement$(): Observable<ParticulierMouvement | null> {
    if (this.coordonneesMouvement.value === null) {
      this.changementCoordonneeMouvementService
        .obtenirCoordonnees$()
        .pipe(
          catchError((err) => {
            this.saveEtatErreur(err);
            return [];
          }),
          tap((data: ParticulierMouvement | null) => {
            this.saveCoordonneesMouvement(data);
          }),
        )
        .subscribe();
    }
    return this.coordonneesMouvement.asObservable();
  }

  modifierCoordonneMouvement$(
    requete: RequeteModifierCoordonneesMouvement,
  ): Observable<ReponseModifierCoordonneesMouvement | null> {
    this.confirmationMouvement.next(null);
    this.changementCoordonneeMouvementService
      .modifierCoordonnees$(requete)
      .pipe(
        catchError((err) => {
          this.saveEtatErreur(err);
          return [];
        }),
        tap((data: ReponseModifierCoordonneesMouvement | null) => {
          this.saveConfirmationMouvement(data);
        }),
      )
      .subscribe();
    return this.confirmationMouvement.asObservable();
  }

  saveCoordonneesMouvement = (coordonneesParticulierMouvement: ParticulierMouvement | null) =>
    this.coordonneesMouvement.next(coordonneesParticulierMouvement);

  getConfirmationMouvement$ = () => this.confirmationMouvement;
  saveConfirmationMouvement = (confirmation: ReponseModifierCoordonneesMouvement | null) =>
    this.confirmationMouvement.next(confirmation);

  getSelector = () => this.selector;
  saveSelector = (selector: string) => this.selector.next(selector);

  getEtatModale = () => this.etatModale;
  saveEtatAfficherModaleAnnuler = (etat: boolean) => this.etatModale.next(etat);

  getEtatModification = () => this.etatModification;
  saveEtatModification = (etatModification: string) => (this.etatModification = etatModification);

  getEtatErreur = () => this.etatErreur;
  saveEtatErreur = (etatErreur: HttpErrorResponse) => this.etatErreur.next(etatErreur);

  getContexteModification = () => this.contexteModification;
  saveContexteModification = (contexteModification: ContexteModificationEnum) =>
    (this.contexteModification = contexteModification);
}
